import Countdown from 'react-countdown'

import { classNames } from '@/utils/helpers'

import { pad } from './utils'

interface Props {
  end: number
  className?: string
}

export const CampaignCountdown = ({ end, className }: Props) => {
  if (end < Date.now()) {
    return null
  }

  return (
    <div className="mt-0 hidden h-min flex-col space-y-1 lg:flex">
      <span className="text-xs leading-[15px]">Time left</span>
      <Countdown
        intervalDelay={1000}
        autoStart
        date={end}
        renderer={(left) => {
          const items = [left.hours, left.minutes, left.seconds]

          if (left.days > 0) {
            items.unshift(left.days)
          }

          return (
            <div
              className={classNames(
                'flex items-center rounded px-2 text-[17px] font-medium leading-[21px] text-white',
                className,
              )}
            >
              {items.map((item) => pad(item, 2)).join(' : ')}
            </div>
          )
        }}
      />
    </div>
  )
}
